import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../features/userSlice";
import { ActionItemsEndPointLogic } from "../logic/AssetManagement/ActionItems/actionItemsEndPointLogic";
import { useSelector } from "react-redux";

export const useActionItemFileUpload = (shared_uid: any, page: string) => {
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as string;
  const [isDragging, setIsDragging] = useState(false);
  const [fileUploadLoading, setFileUploadLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<any>([]); // store files which are we selected brower or drag and drop(when create a new task)
  const [files, setFiles] = useState<any>([]); // store files which are we selected brower or drag and drop (when edit a task)
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  //-- this for when selected files
  const handleFileUpload = (event: any) => {
    const selectedFiles = Array.from(event.target.files);
    processFiles(selectedFiles);
  };

  //-- this for remove files when clicking on cross icon
  const handleRemoveFile = (index: number) => {
    setUploadedFiles((prevFiles: File[]) =>
      prevFiles.filter((_, i) => i !== index)
    );
    
  };

  //-- this for drag and drop
  const handleFileDrop = (event: any) => {
    event.preventDefault();
    setIsDragging(false);

    const newFiles = Array.from(event.dataTransfer.files);
    processFiles(newFiles);
  };

  // -- this for set Files(name, size) in a state(setUploadedFiles), validation, convert file to base64
  const processFiles = (newFiles: any) => {
    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

    newFiles.forEach((file: any) => {
      const fileSizeMB = file.size / (1024 * 1024);
      // Check file size limit
      if (fileSizeMB > 5) {
        //setUploadError('File size exceeds the 5MB limit.');
        dispatch(
          setDisplayErrorSnackBar({
            message: `File size exceeds the 5MB limit.`,
            type: "error",
          })
        );
        return;
      }

      // Check allowed file types
      if (!allowedTypes.includes(file.type)) {
        dispatch(
          setDisplayErrorSnackBar({
            message: `Invalid file type: ${file.name}. Only PDF, JPG, and PNG allowed.`,
            type: "error",
          })
        );
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64String = (reader.result as string).split(",")[1]; // Extract base64 part
        const newFile = {
          file: file.name,
          size: file.size,
          base64: base64String || "", // Base64 encoded string
          progress: 100, // Simulated progress
          status: "Uploaded", // Add status here
        };
        if (page === "create_page")
          setUploadedFiles((prevFiles: any) => [...prevFiles, newFile]);
        if (page === "edit_page")
          setSelectedFiles((prevFiles: any) => [...prevFiles, newFile]);
      };
    });
  };

  // -- MAKE API call for Fetch Files
  const fetchFilesActionItem = async (shared_uid: string) => {
    setFileUploadLoading(true); // Set loading to true before API call
    try {
      await ActionItemsEndPointLogic.getFilesActionItem(
        oauthTokenHeader,
        shared_uid,
        setFiles
      );
      setSelectedFiles([]);
    } catch (error) {
      dispatch({ type: "error", payload: { message: error } });
    } finally {
      setFileUploadLoading(false); // Set false after API finishes
    }
  };

  //-- MAKE API call for Files upload
  const uploadFilesActionItem = async (task_shared_uid: string) => {
    setFileUploadLoading(true); // Set false after API finishes
    try {
      let choosedFiles = page === "edit_page" ? selectedFiles : uploadedFiles;
      const uploadPromises = choosedFiles.map(async (file: any) => {
        const fileUploadBody = {
          object_type: "tasks",
          file_name: file.file, // Extract file name
          file: file.base64, // File in Base64 format
        };

        return ActionItemsEndPointLogic.uploadFileActionItem(
          oauthTokenHeader,
          fileUploadBody,
          task_shared_uid
        );
      });

      // Wait for all uploads to complete
      await Promise.all(uploadPromises);
      if (page === "create_page") setUploadedFiles([]); // Clear uploaded files after successful upload
      if (page === "edit_page") {
        setSelectedFiles([]); // clear selected files
         fetchFilesActionItem(shared_uid); // fetch files from API
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      setFileUploadLoading(false); // Set false after API finishes
    }
  };

  useEffect(() => {
    if (selectedFiles.length === 0) return; // Prevent unnecessary execution
    uploadFilesActionItem(shared_uid);
    // eslint-disable-next-line
  }, [selectedFiles]);

  return {
    uploadedFiles,
    handleFileUpload,
    setUploadedFiles,
    handleRemoveFile,
    handleFileDrop,
    isDragging,
    setIsDragging,
    fileUploadLoading,
    setFileUploadLoading,
    fetchFilesActionItem,
    files,
    setFiles,
    uploadFilesActionItem,
  };
};
